module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.b5f0f10.woff2";